/**
 * EntityHierarchyReversed
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import EntityName from '../EntityName';

// Selectors
import { makeSelectEntityValue } from '../../services/entities/selectors';

interface Props {
    entityId?: number;
    path?: ?string;
}

export class EntityHierarchyReversed extends React.PureComponent<Props> {
    render() {
        const { entityId, path } = this.props;
        const ids =
            path &&
            path
                .split('/')
                .map(Number)
                .filter(value => value)
                .reverse();
        return (
            <React.Fragment>
                <EntityName entityId={entityId} hideEntityType />
                {ids && ' / '}
                {ids &&
                    ids.map((id, index) => (
                        <React.Fragment key={id}>
                            {!!index && ' / '}
                            <EntityName entityId={id} hideEntityType />
                        </React.Fragment>
                    ))}
            </React.Fragment>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    path: makeSelectEntityValue('path')
});

export default connect(mapStateToProps)(EntityHierarchyReversed);
